"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _memberShip = _interopRequireDefault(require("@/components/memberShip.vue"));
var _config = require("@/api/config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      value: '',
      tabsOne: [{
        name: '国内站',
        label: '国内站',
        id: '0'
      }, {
        name: '海外站',
        label: '海外站',
        id: '1'
      }],
      activeNameOne: '0',
      form: {},
      list: [{
        versionDesc: '',
        price: undefined,
        priceDesc: '',
        status: 0,
        //第一个
        originStatus: 0,
        originPrice: '',
        duration: '',
        buttonDesc: '',
        intro: ''
      }, {
        versionDesc2: '',
        price2: undefined,
        priceDesc2: '',
        status2: 0,
        //第一个
        originStatus2: 0,
        originPrice2: '',
        duration2: '',
        buttonDesc2: '',
        intro2: ''
      }, {
        versionDesc3: '',
        price3: undefined,
        priceDesc3: '',
        status3: 0,
        //第一个
        originStatus3: 0,
        originPrice3: '',
        duration3: '',
        buttonDesc3: '',
        intro3: ''
      }],
      newList: [],
      originList: [],
      required: {
        required: true,
        message: '请填写会员版本名称',
        trigger: 'blur'
      },
      rules: {
        name: [{
          required: true,
          message: '请填写版本名称',
          trigger: 'blur'
        }]
      },
      version: 0,
      id: null
    };
  },
  components: {
    MultiLanguageInp: _MultiLanguageInp.default,
    memberShip: _memberShip.default
  },
  computed: {},
  mounted: function mounted() {
    this.getInfoVip();
  },
  methods: {
    onTabs: function onTabs() {
      this.getInfoVip();
    },
    // 文案
    saveList: function saveList(listIntro) {
      console.log('list', listIntro);
      var newIntro = [];
      if (listIntro.length != 0) {
        newIntro = listIntro.map(function (item) {
          return {
            edit: item.edit,
            intro: item.intro
          };
        });
      }
      if (this.version == 0) {
        this.list[0].intro = JSON.stringify(newIntro);
      } else if (this.version == 1) {
        this.list[1].intro2 = JSON.stringify(newIntro);
      } else {
        this.list[2].intro3 = JSON.stringify(newIntro);
      }
    },
    // 回显
    getInfoVip: function getInfoVip() {
      var _this = this;
      console.log('66');
      var params = {
        isOverseas: this.activeNameOne == 0 ? false : true
      };
      (0, _config.queryVip)(params).then(function (res) {
        if (res.data.data && res.data.data.id) {
          _this.id = res.data.data.id;
        } else {
          _this.id = null;
        }
        if (res.data.errno == 0 && res.data.data) {
          var info = res.data.data;
          console.log('info', info);
          _this.list[0].versionDesc = info.versionDesc;
          _this.list[0].price = info.price;
          _this.list[0].priceDesc = info.priceDesc;
          _this.list[0].status = info.status;
          _this.list[0].originStatus = info.originStatus;
          _this.list[0].originPrice = info.originPrice;
          _this.list[0].duration = info.duration;
          _this.list[0].buttonDesc = info.buttonDesc;
          _this.list[0].intro = info.intro;
          _this.list[1].versionDesc2 = info.versionDesc2;
          _this.list[1].price2 = info.price2;
          _this.list[1].priceDesc2 = info.priceDesc2;
          _this.list[1].status2 = info.status2;
          _this.list[1].originStatus2 = info.originStatus2;
          _this.list[1].originPrice2 = info.originPrice2;
          _this.list[1].duration2 = info.duration2;
          _this.list[1].buttonDesc2 = info.buttonDesc2;
          _this.list[1].intro2 = info.intro2;
          _this.list[2].versionDesc3 = info.versionDesc3;
          _this.list[2].price3 = info.price3;
          _this.list[2].priceDesc3 = info.priceDesc3;
          _this.list[2].status3 = info.status3;
          _this.list[2].originStatus3 = info.originStatus3;
          _this.list[2].originPrice3 = info.originPrice3;
          _this.list[2].duration3 = info.duration3;
          _this.list[2].buttonDesc3 = info.buttonDesc3;
          _this.list[2].versionDesc3 = info.versionDesc3;
          _this.list[2].intro3 = info.intro3;
        } else if (res.data.errno == 0 && !res.data.data) {
          _this.list = [{
            versionDesc: '',
            price: undefined,
            priceDesc: '',
            status: 0,
            //第一个
            originStatus: 0,
            originPrice: '',
            duration: '',
            buttonDesc: '',
            intro: ''
          }, {
            versionDesc2: '',
            price2: undefined,
            priceDesc2: '',
            status2: 0,
            //第一个
            originStatus2: 0,
            originPrice2: '',
            duration2: '',
            buttonDesc2: '',
            intro2: ''
          }, {
            versionDesc3: '',
            price3: undefined,
            priceDesc3: '',
            status3: 0,
            //第一个
            originStatus3: 0,
            originPrice3: '',
            duration3: '',
            buttonDesc3: '',
            intro3: ''
          }];
        }
      });
    },
    handleClickOne: function handleClickOne() {},
    setContent: function setContent(version, introInfo) {
      this.version = version;
      this.$refs.memberShip.open(introInfo);
    },
    saveInfo: function saveInfo() {
      var _this2 = this;
      // 需要判断的字段
      var key = ['versionDesc', 'price', 'priceDesc', 'originPrice', 'duration', 'buttonDesc'];
      var key2 = ['versionDesc2', 'price2', 'priceDesc2', 'originPrice2', 'duration2', 'buttonDesc2'];
      var key3 = ['versionDesc3', 'price3', 'priceDesc3', 'originPrice3', 'duration3', 'buttonDesc3'];
      this.adjustKey(key, this.list[0].status, 'price');
      this.adjustKey(key2, this.list[1].status, 'price2');
      this.adjustKey(key3, this.list[2].status, 'price3');
      this.adjustKey(key, this.list[0].originStatus, 'originPrice');
      this.adjustKey(key2, this.list[1].originStatus2, 'originPrice2');
      this.adjustKey(key3, this.list[2].originStatus3, 'originPrice3');
      // 判断必填项
      var status = false,
        status2 = false,
        status3 = false;
      console.log('key3', key3);
      status = this.checkFields(this.list[0], key);
      status2 = this.checkFields(this.list[1], key2);
      status3 = this.checkFields(this.list[2], key3);
      if (status || status2 || status3) {
        return this.$message.warning('请填写必填项');
      }
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.list[0]), this.list[1]), this.list[2]), {}, {
        oversea: this.activeNameOne * 1,
        id: this.id
      });
      (0, _config.saveVip)(params).then(function (res) {
        if (res.data.errno == 0) {
          _this2.$message.success('保存成功');
        }
      });
    },
    adjustKey: function adjustKey(key, status, priceKey) {
      var priceIndex = key.indexOf(priceKey);
      if (status == 0 && priceIndex > -1) {
        key.splice(priceIndex, 1); // 移除价格字段
      } else if (status != 0 && priceIndex === -1) {
        key.push(priceKey); // 确保价格字段存在
      }
    },
    checkFields: function checkFields(list, key) {
      console.log('list', list);
      for (var i = 0; i < key.length; i++) {
        var value = list[key[i]];
        // if (!list[key[i]]) {
        //   return false
        // }
        if (this.isJSON(value)) {
          // 如果是json

          var obj = JSON.parse(value);
          console.log('obj', obj);
          for (var _key in obj) {
            if (!obj[_key]) {
              return true;
            }
          }
        } else if (!value) {
          return true;
        }
      }
      return false;
    },
    isJSON: function isJSON(str) {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
};